const allNotification = { data: [], loading: true };
export const GetCompany = (state = allNotification, action) => {
  switch (action.type) {
    case "Get_Company_Info":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
